import { Link } from "react-router-dom";

export default function GuideSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
            Latest Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Expert <span className="text-primary-500">Spreadsheet Resources</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            In-depth guides to help you master spreadsheet-based product discovery
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
          >
            <div className="relative h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Open%20magazine%20and%20laptop%20displaying%20fashion%20catalog%20on%20white%20oak%20desk%2C%20bright%20natural%20window%20light%2C%20organized%20research%20workspace%20with%20coffee%20cup%20and%20reading%20glasses%2C%20warm%20neutral%20tones%2C%20editorial%20lifestyle%20photography%20with%20gentle%20shadows%2C%20minimalist%20blogger%20aesthetic&width=600&height=360&seq=guide-card-01-v2&orientation=landscape"
                alt="Complete Hipobuy Spreadsheet Guide 2026"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-xs text-foreground-400">July 9, 2026</span>
                <span className="text-xs text-foreground-400">12 min read</span>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                Complete Hipobuy Spreadsheet Guide 2026
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                Everything you need to know about using spreadsheet resources for smart product discovery — from beginner basics to advanced browsing strategies.
              </p>
              <div className="flex items-center gap-1.5 mt-3 text-primary-600 text-sm font-semibold">
                <span>Read Article</span>
                <i className="ri-arrow-right-up-line text-xs group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}